import React from 'react';
import { Box, Typography } from '@mui/material';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import CloudIcon from '@mui/icons-material/Cloud';
import UmbrellaIcon from '@mui/icons-material/Umbrella';
import FilterDramaIcon from '@mui/icons-material/FilterDrama';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';
import { useLanguageContext } from '../../contexts/LanguageContext';

function formatWeekday(dateStr, locale) {
  const d = new Date(dateStr + 'T12:00:00Z');
  return d.toLocaleDateString(locale, { weekday: 'short', timeZone: 'UTC' }).toUpperCase();
}

function formatDayNumber(dateStr) {
  return String(new Date(dateStr + 'T12:00:00Z').getUTCDate());
}

function WeatherIcon({ day }) {
  const props = { sx: { fontSize: 20 } };
  if (day.precipMm24h >= 3) return <UmbrellaIcon {...props} />;
  if (day.cloudCoverPct >= 60) return <CloudIcon {...props} />;
  if (day.cloudCoverPct >= 30) return <FilterDramaIcon {...props} />;
  return <WbSunnyIcon {...props} />;
}

const WeatherWeekStrip = ({ days, selectedDate, onSelectDay }) => {
  const { language } = useLanguageContext();
  const locale = language === 'pl' ? 'pl-PL' : 'en-US';

  return (
    <Box sx={{ display: 'flex', overflowX: 'auto', gap: 1, pb: 1 }}>
      {days.map(day => {
        const isSelected = day.date === selectedDate;
        return (
          <Box
            key={day.date}
            onClick={() => onSelectDay(day)}
            sx={{
              minWidth: 68,
              borderRadius: 2,
              border: `1px solid ${isSelected ? DEFAULT_THEME_COLOR : 'rgba(0,0,0,0.1)'}`,
              bgcolor: isSelected ? DEFAULT_THEME_COLOR : 'white',
              color: isSelected ? 'white' : 'rgba(0,0,0,0.85)',
              p: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              cursor: 'pointer',
              flexShrink: 0,
              transition: 'background 0.15s',
            }}
          >
            <Typography variant="caption" sx={{ textTransform: 'uppercase', fontWeight: 600, opacity: isSelected ? 0.9 : 0.55, fontSize: 10 }}>
              {formatWeekday(day.date, locale)}
            </Typography>
            <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1.3 }}>
              {formatDayNumber(day.date)}
            </Typography>
            <Box sx={{ color: isSelected ? 'white' : DEFAULT_THEME_COLOR, my: 0.3 }}>
              <WeatherIcon day={day} />
            </Box>
            <Typography variant="caption" fontWeight={600} sx={{ fontSize: 12 }}>
              {Math.round(day.airTempMaxC)}°
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default WeatherWeekStrip;
